import React from 'react'
import PropTypes from 'prop-types'

// Material-UI
//   npm install --save material-ui
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'
import TextField from 'material-ui/TextField'

/**
 * OKボタンのみのダイアログ
 * @property {String} title - ダイアログタイトル
 * @property {String} message - メッセージ
 * @property {String} okButtonLabel - OKボタンの文字列
 * @property {func} handleCloseDialog - OKボタンのハンドラー
 * @property {Boolean} isDialogOpen - ダイアログ表示フラグ
 */
export class MessageDialog extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isDialogOpen: this.props.isDialogOpen
    }
  }

  render () {
    let lbl = (this.props.okButtonLabel) ? this.props.okButtonLabel : 'O K'
    return (
      <Dialog
        title={this.props.title}
        actions={[
          <FlatButton
            label={lbl}
            onClick={this.props.handleCloseDialog} />
        ]}
        modal={Boolean(true)}
        open={this.props.isDialogOpen}
        onRequestClose={this.props.handleCloseDialog}>
        <div>
          { this.props.message.replace('\\n', '\n').split('\n').map(function (m, i) { return (<p key={i}>{m}</p>) }) }
        </div>
      </Dialog>
    )
  }
}

/**
 * OK/キャンセル のダイアログ
 * @property {String} title - ダイアログタイトル
 * @property {String} message - メッセージ
 * @property {String} okButtonLabel - OKボタンの文字列
 * @property {func} handleCancelDialog - キャンセルボタンのハンドラー
 * @property {func} handleCloseDialog - OKボタンのハンドラー
 * @property {Boolean} isDialogOpen - ダイアログ表示フラグ
 */
export class GeneralDialog extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isDialogOpen: this.props.isDialogOpen
    }
  }

  render () {
    let lbl = (this.props.okButtonLabel) ? this.props.okButtonLabel : 'O K'
    return (
      <Dialog
        title={this.props.title}
        actions={[
          <FlatButton
            label='キャンセル'
            primary={Boolean(true)}
            onClick={this.props.handleCancelDialog} />,
          <FlatButton
            label={lbl}
            onClick={this.props.handleCloseDialog} />
        ]}
        modal={Boolean(true)}
        open={this.props.isDialogOpen}
        onRequestClose={this.props.handleCancelDialog}>
        <div>
          { this.props.message.replace('\\n', '\n').split('\n').map(function (m, i) { return (<p key={i}>{m}</p>) }) }
        </div>
      </Dialog>
    )
  }
}

GeneralDialog.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  okButtonLabel: PropTypes.string,
  handleCancelDialog: PropTypes.func,
  handleCloseDialog: PropTypes.func,
  isDialogOpen: PropTypes.bool
}

/**
 * パスワード入力用ダイアログ
 * @property {String} title - ダイアログタイトル
 * @property {String} message - メッセージ
 * @property {String} okButtonLabel - OKボタンの文字列
 * @property {func} handleCancelDialog - キャンセルボタンのハンドラー
 * @property {func} handleCloseDialog - OKボタンのハンドラー
 * @property {func} onPasswordChanged - パスワード変更イベントハンドラー
 * @property {String} password - パスワード
 * @property {Boolean} isDialogOpen - ダイアログ表示フラグ
 */
export class PasswordDialog extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      isDialogOpen: this.props.isDialogOpen,
      inputPW: this.props.password || ''
    }
    this.handlePasswordChanged = this.handlePasswordChanged.bind(this)
  }

  handlePasswordChanged (e) {
    let v = e.target.value
    if (v !== this.state.inputPW) {
      this.setState({inputPW: v})
      if (typeof this.props.onPasswordChanged === 'function') {
        this.props.onPasswordChanged(e)
      }
    }
  }

  render () {
    let lbl = (this.props.okButtonLabel) ? this.props.okButtonLabel : 'O K'
    return (
      <Dialog
        title={this.props.title}
        actions={[
          <FlatButton
            label='キャンセル'
            primary={Boolean(true)}
            onClick={this.props.handleCancelDialog} />,
          <FlatButton
            label={lbl}
            disabled={this.state.inputPW.length < 1}
            onClick={this.props.handleCloseDialog} />
        ]}
        modal={Boolean(true)}
        open={this.props.isDialogOpen}
        onRequestClose={this.props.handleCancelDialog}>
        <div>
          { this.props.message.replace('\\n', '\n').split('\n').map(function (m, i) { return (<p key={i}>{m}</p>) }) }
        </div>
        <div>
          <TextField floatingLabelText='パスワード' type='password' value={this.state.inputPW}
            onChange={this.handlePasswordChanged} />
        </div>
      </Dialog>
    )
  }
}

PasswordDialog.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  okButtonLabel: PropTypes.string,
  handleCancelDialog: PropTypes.func,
  handleCloseDialog: PropTypes.func,
  onPasswordChanged: PropTypes.func,
  password: PropTypes.string,
  isDialogOpen: PropTypes.bool
}



// WEBPACK FOOTER //
// ./src/Dialogs.js